import { MenuItem, TextField, ListItem } from '@mui/material';
import { NewIntegrationType, CurrentIntegrationType } from 'interfaces/integrations';
import { useTranslation } from 'react-i18next';
import { integrationConfig } from 'pages/devSettings/components/integrationConfig';
import { Switch } from '../../ovComponents/2-component';

enum ProcessorName {
  Apex = 'Apex',
  Drivewealth = 'Drivewealth',
}

interface IntegrationsConfigurationProps {
  integration: NewIntegrationType | CurrentIntegrationType;
  setIntegrationConfiguration: (newConfig: any) => void;
  setIntegrationAttributes: (attributes: any) => void;
}

const IntegrationsConfiguration = ({ integration, setIntegrationConfiguration, setIntegrationAttributes }: IntegrationsConfigurationProps) => {
  const { t } = useTranslation(['devSettings']);
  if (!integration?.type) return null;
  const integrationTypeConfig = integrationConfig[integration?.type];
  const integrations = integrationTypeConfig?.integration;

  if (!integrations) return null;
  const findIntegration = integrations?.find((x: any) => x.provider === integration.provider);
  const booleanFields = ['enableNameMatching'];
  const multiLineFields = ['integrationRsaPrivateKey'];
  const dropdownFields = ['processorName'];
  const dropdownFieldsNotRequired = ['processorName'];

  return (
    <>
      {integrationTypeConfig?.attributes?.map((x) => {
        if (x.type === 'text') {
          return (
            <ListItem key={x.name as string}>
              <TextField
                value={(integration as any)[x.name] ?? ''}
                label={t(`integrationsModal.attributes.${x.name}`)}
                fullWidth
                required={x.required}
                onChange={(e: any) => {
                  setIntegrationAttributes({ ...integration, [x.name]: e.target.value });
                }}
              />
            </ListItem>
          );
        }
        if (x.type === 'boolean') {
          return (
            <ListItem key={x.name as string}>
              <Switch
                label={t(`integrationsModal.attributes.${x}`)}
                checked={(integration as any)[x.name] ?? false}
                onChange={(e: any) => {
                  setIntegrationAttributes({ ...integration, [x.name]: e });
                }}
              />
            </ListItem>
          );
        }
        return null;
      })}
      {findIntegration?.configuration?.map((x: string) => (dropdownFields.includes(x) ? (
          <ListItem key={x as string}>
            <TextField
              required = {!dropdownFieldsNotRequired.includes(x)}
              select
              fullWidth
              value={integration.configuration[x] ?? ''}
              label={t(`integrationsModal.configuration.${x}`)}
              onChange={(e: any) => setIntegrationConfiguration({ ...integration.configuration, [x]: e.target.value as string })}
            >
              {(
                  Object.values(ProcessorName).map((processorName) => (
                    <MenuItem key={processorName} value={processorName}>
                      {processorName}
                    </MenuItem>
                  ))
              )}
            </TextField>
          </ListItem>
      ) : booleanFields.includes(x) ? (
          <ListItem key={x as string}>
            <Switch
              label={t(`integrationsModal.configuration.${x}`)}
              checked={integration.configuration[x] ? integration.configuration[x] : false}
              onChange={(e: any) => {
                setIntegrationConfiguration({ ...integration.configuration, [x]: e });
              }}
            />
          </ListItem>
      ) : (
          <ListItem key={x as string}>
            <TextField
              required
              multiline={multiLineFields.includes(x) ? true : undefined}
              value={integration.configuration[x] ? integration.configuration[x] : ''}
              label={t(`integrationsModal.configuration.${x}`)}
              fullWidth
              onChange={(e: any) => {
                setIntegrationConfiguration({ ...integration.configuration, [x]: e.target.value });
              }}
            />
          </ListItem>
      )
      ))}
    </>
  );
};

export default IntegrationsConfiguration;
